module.exports = {
  tapOrDrop: "Tap or Drop file here.",
  load: "LOAD"
}


// WEBPACK FOOTER //
// ../i18n/en/loadFile.js